import { getCurrentAccount, initFirebase } from '@onhandtech/onhand-fe-shared/lib/firebase'
import {
  setAuthenticated,
  setLoading,
} from '@onhandtech/onhand-fe-shared/lib/firebase/redux/actions'
import { getConfig } from 'config/configuration'
import { ONHAND_EMAIL_DOMAIN } from 'constants/staff'
import type firebase from 'firebase'
import { setAuthInitialized, setIsStaffUser } from 'redux/authentication/actions'
import type { SagaIterator } from 'redux-saga'
import { call, put } from 'redux-saga/effects'

export function* bootstrapAuthenticationSaga(): SagaIterator {
  const { firebase: fbConfig } = getConfig()

  const firebaseConfig = {
    apiKey: process.env.FIREBASE_API_KEY ?? '',
    authDomain: fbConfig.authDomain,
    databaseURL: fbConfig.dbUrl,
    projectId: fbConfig.projectId,
    storageBucket: fbConfig.storageBucket,
    messagingSenderId: fbConfig.messagingSenderId,
    appId: fbConfig.appId,
  }

  if (firebaseConfig.apiKey && firebaseConfig.apiKey !== 'undefined') {
    yield put(setLoading({ serviceName: 'signIn', payload: true }))

    yield call(initFirebase, {
      firebaseConfig,
      measurementId: fbConfig.measurementId,
    })

    const currentUser: firebase.User | null = yield call(getCurrentAccount)

    if (currentUser?.email) {
      // Can't redirect here as we have no access to react-router-dom
      // window.location will refresh the firebase session
      yield put(setAuthenticated(true))
      yield put(setIsStaffUser(currentUser.email.includes(ONHAND_EMAIL_DOMAIN)))
      yield put(setLoading({ serviceName: 'signIn', payload: false }))
      yield put(setAuthInitialized(true))
      return []
    }

    yield put(setLoading({ serviceName: 'signIn', payload: false }))
    yield put(setAuthInitialized(true))
    return
  }

  return []
}
